import type { IPricingStory } from './types';
import pricingMaxContactsImage from '../max-contacts/static/pricing-max-contacts.png';
import pricingModalImage from '../modal-content/static/pricing-modal-image.jpg';

const data: IPricingStory = {
  imageData: {
    file: {
      childImageSharp: {
        gatsbyImageData: {
          height: 844,
          images: {
            fallback: {
              src: pricingModalImage,
            },
          },
          layout: 'constrained',
          width: 822,
        },
      },
    },
  },
  mixedMedia: {
    mediaType: 'image',
    image: {
      altText: '',
      gatsbyImage: {
        height: 552,
        images: {
          fallback: {
            src: pricingMaxContactsImage,
          },
        },
        layout: 'constrained',
        width: 608,
      },
    },
  },
};

export default data;
